// Prefetch critical resources for faster navigation
export const prefetchCriticalResources = () => {
  if (typeof window === 'undefined') return;

  // Prefetch DNS for external APIs
  const prefetchLink = (href: string, rel = 'dns-prefetch') => {
    const link = document.createElement('link');
    link.rel = rel;
    link.href = href;
    document.head.appendChild(link);
  };

  // DNS prefetch for APIs
  prefetchLink('https://www.googleapis.com');
  prefetchLink('https://itunes.apple.com');
  prefetchLink('https://mmnfjeukxandnhdaovzx.supabase.co');

  // There used to be a modulepreload list here of '/src/pages/Discovery.tsx',
  // '/src/pages/Index.tsx' and '/src/hooks/useAuth.tsx'. Those are dev-server
  // paths: in production each one was a 404 on every page load, and all three
  // modules are already in the entry bundle, so there was nothing to preload.
};

// Call on app start
if (typeof window !== 'undefined') {
  // Defer prefetching to avoid blocking initial render
  setTimeout(prefetchCriticalResources, 100);
}